import { Component, Input, OnInit } from '@angular/core';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar } from '@angular/material';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditEventFeaturesComponent } from '../edit-event-features/edit-event-features.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';

@Component({
  selector: 'app-event-features',
  templateUrl: './event-features.component.html',
  styleUrls: ['./event-features.component.scss']
})
export class EventFeaturesComponent implements OnInit {
  @Input() aviationEvent: AviationEvent;
  editModeSet = false;
  isFlightDeckAdmin = false;

  constructor(private _editDescDialog: MatDialog,
              private _toggleService: EditToggleService,
              private businessManagerService: BusinessManagerService,
              public snackBar: MatSnackBar) { }

  async ngOnInit() {
    this.isFlightDeckAdmin = await this.businessManagerService.isFlightDeckAdmin();
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  get hasContent(): boolean {
    return (this.aviationEvent.isFeatured || this.aviationEvent.isValidated || this.aviationEvent.hasAopaPresence
      || this.aviationEvent.isAopaHosted);
  }

  openEditEventFeaturesDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '800px';
    dialogConfig.data = {aviationEvent: this.aviationEvent};

    const DIALOG_REF = this._editDescDialog.open(EditEventFeaturesComponent, dialogConfig);
    this._handleModalClose(DIALOG_REF);
  }

  /**
   * listens for dialog close event. Opens snackbar if necessary
   * @param {MatDialogRef<any>} dialogRef
   * @private
   */
  _handleModalClose ( dialogRef: MatDialogRef<any>) {
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';

    dialogRef.afterClosed().subscribe((success) => {
      if (success === null) { return; }
      if (success) {
        this.snackBar.open('Event Special Features', 'Updated', {
          duration: 3000
        });
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
